import { render, staticRenderFns } from "./BaseCollectionList.vue?vue&type=template&id=72cfd75c"
import script from "./BaseCollectionList.vue?vue&type=script&lang=js"
export * from "./BaseCollectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports